// extracted by mini-css-extract-plugin
module.exports = {"content":"Channel_content__2qoA7","one-tab-only":"Channel_one-tab-only__3kz_T","oneTabOnly":"Channel_one-tab-only__3kz_T"};